import { render, staticRenderFns } from "./AnchorVesselCard.vue?vue&type=template&id=6f23bd98&scoped=true&"
import script from "./AnchorVesselCard.vue?vue&type=script&lang=js&"
export * from "./AnchorVesselCard.vue?vue&type=script&lang=js&"
import style0 from "./AnchorVesselCard.vue?vue&type=style&index=0&id=6f23bd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f23bd98",
  null
  
)

export default component.exports